<div class="container">
  <mat-card class="login-card">
    <mat-card-header>
      <h5 class="mat-h1">Przywracanie hasła</h5>
    </mat-card-header>
    <mat-card-content>
      <form #form="ngForm" (ngSubmit)="form.valid && onSubmit(form)" autocomplete="off">
        <div mat-dialog-content>

          <mat-form-field class="full-width" appearance="fill">
            <mat-label>kod zmiany hasła</mat-label>
            <input matInput autocomplete="off" name="code" [(ngModel)]="code" required="true" />
          </mat-form-field>
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>nowe hasło</mat-label>
            <input matInput autocomplete="off" name="newPassword" [(ngModel)]="newPassword" required="true"
              type="password" />
          </mat-form-field>
        </div>
        <div mat-dialog-actions>
          <button mat-flat-button color="primary" type="submit">Zmień hasło</button>
        </div>
      </form>
      <div class="footer" fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="gappx">
        <a routerLink="/login" routerLinkActive="active">powrót do logowania</a>
      </div>
    </mat-card-content>
  </mat-card>
</div>